/**
 * @file CheckBoxToggle
 */
'use strict'

/**
 * @classname CheckBoxToggle
 * @classdesc CheckBoxToggle
 */
export default class CheckBoxToggle {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('CheckBoxToggle.constructor')
		this._$e = $e
		this._target = $e.attr('data-target-toggle')
		this._$target = $(this._target)

		$e.on('click', () => this.onClick())
		this.onClick()
	}

	/**
	 * クリックのコールバック
	 *
	 * @memberof CheckBoxToggle
	 * @return {undefined}
	 */
	onClick() {
		console.log('CheckBoxToggle.onClick')
		if (this._$e.prop('checked')) {
			this._$target.slideDown().removeClass('ignore-validate')
		} else {
			this._$target.slideUp().addClass('ignore-validate').removeClass('is-invalid')
		}
	}
}
